<template>
  <a-modal v-model.trim="visible" :title="$t('applyRerunBox')" width="800px" :okText="$t('confirm')" @ok="submit">
    <template>
      <a-form-model :model="editForm" layout="vertical" :rules="validateRules" ref="editForm">
        <a-form-model-item :label="$t('planReturnBoxTime')" prop="BEGIN_DATE">
          <dol-date style="width: 200px;" :placeholder="$t('pleaseSelectADate')" v-model.trim="editForm.BEGIN_DATE" @change="pickBeginDate"/>
          ~
          <dol-date style="width: 200px;" :placeholder="$t('pleaseSelectADate')" v-model.trim="editForm.END_DATE"/>
        </a-form-model-item>
      </a-form-model>
    </template>
    <div class="apply-return-order">
      <a-collapse class="apply-return-order-box" v-model="activeKey" expandIconPosition="right">
        <template v-for="order in orderList">
          <a-collapse-panel :key="order.XB_SHEET_CODE">
            <template #header>
              <div class="apply-return-order-header">
                <span class="apply-return-order-header-title">{{ $t('orderID') }}：{{ order.XB_SHEET_CODE }}</span>
                <span class="apply-return-order-header-chose">（{{ $t('通用_已选') }} {{ order.TOTAL }}）</span>
              </div>
            </template>
            <template v-for="city in order.CITY_LIST">
              <div>
                {{$dt(city, 'CITY_NAME')}}：
                <template v-for="box in city.BOX_LIST">
                  <a-tag>{{box.BOX_CODE}}</a-tag>
                </template>
              </div>
            </template>
          </a-collapse-panel>
        </template>
      </a-collapse>
    </div>
  </a-modal>
</template>

<script>
export default {
  name: 'apply-return-modal',
  mixins: [],
  components: {},
  data () {
    return {
      visible: false,
      boxList: [],
      activeKey: [],

      editForm: {},
      loading: false,
    };
  },
  computed: {
    uploadParams () {
      return {};
    },
    validateRules(){
      const rules = {};
      rules.BEGIN_DATE = [{required: true, message: this.$t('pleaseSelectTheStartDateOfReturn'), trigger: ['blur','change']}];
      return rules;
    },

    // 显示数据
    orderList(){
      const orderList = [], orderMap = {}, orderCityMap = {};
      this.boxList.forEach(box => {
        if(!orderMap[box.XB_SHEET_CODE]){
          orderMap[box.XB_SHEET_CODE] = {
            XB_SHEET_CODE: box.XB_SHEET_CODE,
            TOTAL: 0,
            CITY_LIST: [],
          }
          orderList.push(orderMap[box.XB_SHEET_CODE])
        }
        if(!orderCityMap[box.XB_SHEET_CODE + (box.DIFF_CITY_NAME || box.D_CITY_NAME)]){
          orderCityMap[box.XB_SHEET_CODE + (box.DIFF_CITY_NAME || box.D_CITY_NAME)] = {
            CITY_ID: box.DIFF_CITY_ID || box.D_CITY_ID,
            CITY_NAME: box.DIFF_CITY_NAME || box.D_CITY_NAME,
            CITY_NAME_ENG: box.DIFF_CITY_NAME_ENG || box.D_CITY_NAME_ENG,
            CITY_NAME_RUS: box.DIFF_CITY_NAME_RUS || box.D_CITY_NAME_RUS,
            BOX_LIST: [],
          }
          orderMap[box.XB_SHEET_CODE].CITY_LIST.push(orderCityMap[box.XB_SHEET_CODE + (box.DIFF_CITY_NAME || box.D_CITY_NAME)]);
        }
        orderMap[box.XB_SHEET_CODE].TOTAL++;
        orderCityMap[box.XB_SHEET_CODE + (box.DIFF_CITY_NAME || box.D_CITY_NAME)].BOX_LIST.push(box);
      });
      return orderList;
    },
  },
  methods: {
    open (boxList) {
      this.boxList = boxList;
      this.activeKey = this.orderList.map(item => item.XB_SHEET_CODE);
      this.visible = true;
    },

    pickBeginDate(){
      if(this.editForm.BEGIN_DATE && !this.editForm.END_DATE) {
        this.$set(this.editForm, 'END_DATE', this.$moment(this.editForm.BEGIN_DATE).add(7, 'day').format('YYYY-MM-DD'));
      }
    },

    submit(){
      this.$refs.editForm.validate(v => {
        if(!v){
          return false;
        }

        const submitData = [];
        this.orderList.forEach(order => {
          const data = { OT_XG_INFO: [] };
          order.CITY_LIST.forEach(city => {
            city.BOX_LIST.forEach(box => {
              data.OT_XG_INFO.push({
                VOUCHER_ID: box.XF_MASTER_ID, // 提箱单ID
                TARGET_ID: box.XD_COMPANY_ID, // 箱东ID
                PARENT_FLOW_ID: box.XF_FLOW_ID, // 提箱单流水ID
                BOX_FLOW_ID: box.BOX_FLOW_ID, // 箱流水ID
                BOX_ID: box.BOX_ID, // 箱ID
                BEGIN_DATE: this.editForm.BEGIN_DATE,
                END_DATE: this.editForm.END_DATE,
                XD_MASTER_ID : box.XD_MASTER_ID,
                XD_SHEET_CODE : box.XD_SHEET_CODE,
                D_CITY_ID: city.CITY_ID,
              })
            })
          });
          submitData.push(data);
        });

        this.loading = true;
        this.$h5Api({
          type: '4033',
          data: submitData,
        }).then(() => {
          this.visible = false;
          this.$message.info(String(this.$t('提示_货方申请还箱成功')));
          this.$emit('refresh');
        }).finally(() => {
          this.loading = false;
        })
      })
    }
  },
  created () {
  },
};
</script>

<style scoped lang="scss">
.apply-return-order {
  .apply-return-order-box {
    margin-top: 16px;
  }

  .apply-return-order-header {
    display: flex;
    align-items: center;

    .apply-return-order-header-title {
      margin-left: 8px;
      font-weight: 600;
      color: #333333;
    }

    .apply-return-order-header-chose {
      color: #666666;
      font-size: 12px;
    }
  }
}
</style>